import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-a950202a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course-wrapper"
};
const _hoisted_2 = {
  class: "course-title"
};
const _hoisted_3 = {
  class: "more"
};
const _hoisted_4 = ["href"];

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多", -1));

const _hoisted_6 = {
  class: "course-list"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "course-content"
};
const _hoisted_9 = {
  class: "course-name"
};

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "course-line"
}, null, -1));

const _hoisted_11 = {
  class: "course-other"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "teacher-name"
};
const _hoisted_14 = {
  class: "course-org"
};
const _hoisted_15 = {
  key: 0,
  class: "no-data",
  style: {
    "margin-bottom": "40px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ArrowRight = _resolveComponent("ArrowRight");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_Empty = _resolveComponent("Empty");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString($props.menu.module_name), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("a", {
    href: `/courseList.html?type=2&name=${$props.menu.module_name}&menuId=${$props.menu.menu_id}`
  }, [_hoisted_5, _createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_ArrowRight)]),
    _: 1
  })], 8, _hoisted_4)]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.homeCourseList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "course-card",
      style: _normalizeStyle({
        'background-image': `url(${item.course_cover_url})`
      }),
      key: item.id,
      onClick: $event => $options.goDetail(item)
    }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.course_name), 1), _hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
      src: item.avatar || require('@/assets/images/user_avatar.jpg'),
      class: "course-teacher",
      alt: ""
    }, null, 8, _hoisted_12), _createElementVNode("span", _hoisted_13, _toDisplayString(item.lecturer), 1), _createElementVNode("div", _hoisted_14, _toDisplayString(item.organ_name), 1)])])], 12, _hoisted_7);
  }), 128))]), $data.homeCourseList.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_Empty)])) : _createCommentVNode("", true)]);
}